<template>
    <b-col lg="3" md="6">
        <b-row class="max-height">
            <b-col class="solution-tile bg-white solution-empty cursor" v-on:click="openDemo">
                <p class="add-solution-text">
                    <slot></slot>
                </p>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    export default {
        name: "PmisSolutionEmpty",
        methods: {
            openDemo() {
                this.$modal.show("add-new-solution-modal-dialog", {"title": "Dodaj svojo rešitev"}
                );

            }
        }
    }
</script>

<style lang="scss" scoped>
    .cursor {
        cursor: pointer;
    }

    .add-solution-text {
        color: $pmis-grey;
        font-size: 1.8em;
        text-align: center;
    }

    .solution-empty {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
    }

    .solution-empty:hover {
        font-weight: bold;
    }
</style>
